/**
 * Pattern class name
 */
/* istanbul ignore next - That can be used in sails, standalone or other context to select an youtube-video pattern */
export var YOUTUBE_VIDEO_BASE_CLASSNAME = 'ws10-youtube-video';
